import React from 'react';
import { VectorCapitalSimulatorProvider } from './vectorCapital/VectorCapitalSimulatorContext';
import VectorCapitalFullLayout from './vectorCapital/VectorCapitalFullLayout';

function VectorCapitalPlusSimulator(props) {
  return (
    <VectorCapitalSimulatorProvider {...props}>
      <VectorCapitalFullLayout />
    </VectorCapitalSimulatorProvider>
  );
}

export default VectorCapitalPlusSimulator;
